import { gql } from 'graphql-request'

export const UPDATE_STORY = gql`
  mutation UpdateBook($updateBookInput: UpdateBookInput!) {
    updateBook(updateBookInput: $updateBookInput) {
      id
      writer
      penName {
        id
        user {
          id
        }
      }
      skuId
      rating {
        id
      }
      tags {
        id
        name
      }
      category {
        id
      }
      chapterType
      coverImgPath
      title
      intro
      cover
      orientation
      naiinCoverImgPath
      naiinTitle
      naiinCover
      naiinLink
      price
      status
      isTranslated
      writingType
      screenCapturable
      commentable
      guestCommentable
      offlineReadable
      isEpub
      isPdf
      isEnded
      bookType
      publishedAt
      isEbook
      bookStory {
        name
        content
      }
    }
  }
`
